import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_COMMUNITY_UPDATES ({ commit, state }) {
    const query = `query gemeindeUpdates($order_by: OssGemeindeupdatesSort $where: OssGemeindeupdatesFilter) {
      gemeindeUpdates(order_by: $order_by where: $where) {
        id
        title
        fromDate
        toDate
        lastUpdate
        textBlocks{
          id
          title
          text
          date
          order
        }
      }
    }`

    const variables = {
      order_by: {
        fromDate: 'DESC',
        toDate: 'DESC'
      },
      where: {
        id_not_in: state.dissMissedUpdates
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_COMMUNIY_UPDATES', data.data.gemeindeUpdates)
    }

    return data
  }
}
